<template>
  <div>
    <LTSHeader></LTSHeader>
    <div class="container">
      <div v-if="error" class="card">
        <div class="card-header bg-danger text-white text-bold text-center">{{ error }}</div>
      </div>
      <div class="header-section">
        <div class="text-bold">Administrator: User Edit</div>
        <div class="back-btn">
          <router-link class="btn-sm bg-primary text-white text-bold" to="/usersearch">
            <img src="../assets/arrow-left.svg" alt /> Back
          </router-link>
        </div>
      </div>
      <div class="user-details-section">
        <div class="row mb-1">
          <div class="col mr-1">
            <label for="guid">GUID</label>
            <input v-model="user.userId" type="text" class="textbox" id="name" name="name" readonly />
          </div>
          <div class="col">
            &nbsp;
          </div>
        </div>
        <div class="row mb-1">
          <div class="col mr-1">
            <label for="name">Name</label>
            <input v-model="user.name" type="text" class="textbox" id="name" name="name" />
          </div>
          <div class="col">
            <label for="surname">Surname</label>
            <input v-model="user.surname" type="text" class="textbox" id="surname" name="surname" />
          </div>
        </div>
        <div class="row mb-1">
          <div class="col mr-1">
            <label for="email">Email</label>
            <input v-model="user.email" type="text" class="textbox" id="email" name="email" />
          </div>
          <div class="col">
            <label for="username">Username</label>
            <div style="display: flex;">
              <input
                v-model="user.username"
                type="text"
                class="textbox"
                id="username"
                name="username"
                :readonly="!isEditingUsername"
              />
              <button v-if="!isEditingUsername && !isSavingUsername" @click.prevent="editUsername" class="btn-sm bg-primary text-white ml-1">Edit</button>
              <button v-if="isEditingUsername && !isSavingUsername" @click.prevent="saveUsername" class="btn-sm bg-primary text-white ml-1">Save</button>
              <button v-if="isEditingUsername && !isSavingUsername" @click.prevent="cancelEditUsername" class="btn-sm bg-primary text-white ml-1">Cancel</button>
              <Loader v-if="isSavingUsername" class="link-loader"></Loader>
            </div>
            <small v-show="username_invalid" class="required">Please enter a username.</small>
          </div>
        </div>
        <div style="text-align: right;">
          <div>
            <button @click.prevent="deleteAccount" class="btn bg-primary text-white mr-2">Delete User Account</button>
          </div>
        </div>
        <h4 class="mt-1">Linked Profiles</h4>
        <table class="linked-profiles-table">
          <tr>
            <th style="width: 10%;">Database</th>
            <th style="width: 10%;">User Id</th>
            <th style="width: 30%;">Firm</th>
            <th style="width: 20%;">Permissions</th>
            <th style="width: 15%;">Open Documents</th>
            <th style="width: 15%;">Active</th>
            <th colspan="2">&nbsp;</th>
          </tr>
          <tr v-for="(profile, i) in user.linkedProfiles" :key="i">
            <td>{{profile.applicationDescription}}</td>
            <td>{{profile.userProfileId}}</td>
            <td>{{profile.firmName}}</td>
            <td>{{profile.permissions}}</td>
            <td>{{profile.openDocumentCount}}</td>
            <td>{{profile.active}}</td>
            <td>
              <button
                v-if="!isUnlinking"
                class="btn-sm bg-primary text-white text-bold"
                @click.prevent="removeProfile(profile.applicationId, profile.userProfileId)"
              >Remove</button>
              <Loader v-if="isUnlinking" class="link-loader"></Loader>
            </td>
          </tr>
          <tr v-if="user.linkedProfiles.length == 0">
            <td colspan="7">No linked profiles</td>
          </tr>
        </table>
      </div>
      <!-- Tab links -->
      <div class="tab">
        <button @click.prevent="selectedTab = 'logs'" class="tablinks" :class="(selectedTab == 'logs') ? 'active' : ''">User Logs</button>
        <button @click.prevent="selectedTab = 'linkprofiles'" class="tablinks" :class="(selectedTab == 'linkprofiles') ? 'active' : ''">Link Profiles</button>
      </div>
      <div v-if="selectedTab == 'linkprofiles'" class="card">
        <div
          class="card-header text-black font-bold"
        >Search Databases for profiles to add to the user account</div>
        <div class="card-body filters-section">
          <div class="row mb-1">
            <div class="col mr-1">
              <label for="ltsUserId">LTS User Id</label>
              <input v-model="ltsUserIdFilter" type="text" class="textbox" id="ltsUserId" name="ltsUserId" />
            </div>
            <div class="col">
              &nbsp;
            </div>
          </div>
          <div class="row mb-1">
            <div class="col mr-1">
              <label for="name">Name</label>
              <input v-model="nameFilter" type="text" class="textbox" id="name" name="name" />
            </div>
            <div class="col">
              <label for="surname">Surname</label>
              <input
                v-model="surnameFilter"
                type="text"
                class="textbox"
                id="surname"
                name="surname"
              />
            </div>
          </div>
          <div class="row mb-1">
            <div class="col mr-1">
              <label for="email">Email</label>
              <input v-model="emailFilter" type="text" class="textbox" id="email" name="email" />
            </div>
            <div class="col">
              <label for="username">Username</label>
              <input
                v-model="usernameFilter"
                type="text"
                class="textbox"
                id="username"
                name="username"
              />
            </div>
          </div>
          <div class="search-button">
            <button
              @click.prevent="userSearch"
              class="btn bg-primary text-white mr-2"
              :disabled="disableSearch"
            >Search</button>
          </div>
          <Loader v-show="isSearching" class="searching-loader"></Loader>
          <div v-if="hasSearched && !isSearching">
            <h4 class="mt-1">Results</h4>            
            <table>
              <tr>
                <th style="width: 5%;">Type</th>
                <th style="width: 10%;">Database</th>
                <th style="width: 5%;">User Id</th>
                <th style="width: 15%;">Name</th>
                <th style="width: 15%;">Email</th>
                <th style="width: 15%;">Firm</th>
                <th style="width: 10%;">Permissions</th>
                <th style="width: 10%;">Open Documents</th>
                <th style="width: 5%;">Active</th>
                <th colspan="2">&nbsp;</th>
              </tr>
              <tr v-for="(user, i) in searchedUsers" :key="i">
                <td>{{user.applicationType}}</td>
                <td>{{user.applicationDescription}}</td>
                <td>{{user.userProfileId}}</td>
                <td>{{user.name}}</td>
                <td>{{user.email}}</td>
                <td>{{user.firmName}}</td>
                <td>{{user.permissions}}</td>
                <td>{{user.openDocumentCount}}</td>
                <td>{{user.active}}</td>
                <td>
                  <button
                    v-if="!isLinking"
                    class="btn-sm bg-primary text-white text-bold"
                    @click.prevent="linkProfile(user.applicationId, user.userProfileId)"
                  >Link</button>
                  <Loader v-if="isLinking" class="link-loader"></Loader>
                </td>
              </tr>
              <tr v-if="searchedUsers.length == 0">
                <td colspan="7">No users found</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div v-if="selectedTab == 'logs'" class="card">
        <div
          class="card-header text-black font-bold"
        >User logs</div>
        <div class="card-body filters-section">
          <div style="display: flex; flex-direction: row;">
            <label>Log Type:</label>
            <div class="logfilters ml-1 mb-1">
              <div v-for="(logType, i) in user.userLogTypes" :key="i" style="margin-bottom: 0.2rem;">
                <input type="checkbox" :id="logType" :name="logType" :value="logType" v-model="checkedLogFilters" @change="filterLogs">
                <label class="ml-1" :for="logType">{{logType}}</label>
              </div>
              <button class="btn-sm bg-primary text-white text-bold" @click.prevent="selectAllLogFilters">Select All</button>
              <button class="btn-sm bg-primary text-white text-bold ml-1" @click.prevent="deselectAllLogFilters">Deselect All</button>
            </div>        
          </div>
          <table>
            <tr>
              <th>Date</th>
              <th>Type</th>
              <th>Message</th>
              <th>Requested By</th>
            </tr>
            <tr v-for="(log, i) in userLogs" :key="i">
              <td>{{log.date}}</td>
              <td>{{log.type}}</td>
              <td>{{log.message}}</td>
              <td>{{log.requestedBy}}</td>
            </tr>
            <tr v-if="userLogs.length == 0">
                <td colspan="4">No logs.</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LTSHeader from "@/components/LTSHeader";
import Loader from "@/components/Loader.vue";
import axios from "axios";

export default {
  components: {
    LTSHeader,
    Loader
  },
  data: function() {
    return {
      error: "",
      userAccountId: "",
      user: { linkedProfiles: [], userEditLogs: [], userLogTypes: [] },
      isSearching: false,
      ltsUserIdFilter: "",
      nameFilter: "",
      surnameFilter: "",
      emailFilter: "",
      usernameFilter: "",
      hasSearched: false,
      searchedUsers: [],
      isLinking: false,
      isUnlinking: false,
      username_invalid: false,
      isSavingUsername: false,
      originalUsername: "",
      isEditingUsername: false,
      selectedTab: "logs",
      userLogs: [],
      checkedLogFilters: []
    };
  },
  mounted() {
    this.userAccountId = this.$route.query.ID;
    this.loadUser();
  },
  computed: {
    disableSearch: function() {
      return (
        this.ltsUserIdFilter.length === 0 &&
        this.nameFilter.length === 0 &&
        this.surnameFilter.length === 0 &&
        this.emailFilter.length === 0 &&
        this.usernameFilter.length === 0
      );
    }
  },
  methods: {
    loadUser: function() {
      axios
        .get("/useredit/" + this.userAccountId)
        .then(response => {
          this.user = response.data;
          this.originalUsername = this.user.username;

          // make a seperate array for the logs that we can filter on and keep the original array in tact.
          this.userLogs = this.user.userEditLogs;

          // Make sure all the log type filters are checked
          this.checkedLogFilters = this.user.userLogTypes;
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    userSearch: function() {
      this.error = "";
      this.hasSearched = true;
      this.isSearching = true;

      axios
        .post("/useredit", {
          ltsUserId: this.ltsUserIdFilter,
          name: this.nameFilter,
          surname: this.surnameFilter,
          email: this.emailFilter,
          username: this.usernameFilter
        })
        .then(response => {
          this.searchedUsers = response.data;
          console.log(this.searchedUsers);
        })
        .catch(err => {
          this.error =
            "Could not load the users list from the server. Please contact technical support.";
          console.log(err.response);
        })
        .finally(() => {
          this.isSearching = false;
        });
    },
    removeProfile: function(applicationId, userProfileId) {
      this.error = "";
      this.isUnlinking = true;

      axios
        .post("/useredit/unlink", {
          UserId: this.userAccountId,
          ApplicationId: applicationId.toString(),
          UserProfileId: userProfileId.toString()
        })
        .then(() => {
          // this.searchedUsers = this.searchedUsers.filter(
          //   u =>
          //     u.applicationId != applicationId &&
          //     u.userProfileId != userProfileId
          // );

          this.loadUser();
        })
        .catch(err => {
          this.error =
            "Could not unlink the user profile. Please contact technical support.";
          console.log(err.response);
        })
        .finally(() => {
          this.isUnlinking = false;
        });
    },
    linkProfile: function(applicationId, userProfileId) {
      this.error = "";
      this.isLinking = true;

      axios
        .post("/useredit/link", {
          UserId: this.userAccountId,
          ApplicationId: applicationId.toString(),
          UserProfileId: userProfileId.toString()
        })
        .then(() => {
          this.searchedUsers = this.searchedUsers.filter(
            u =>
              u.applicationId != applicationId &&
              u.userProfileId != userProfileId
          );

          this.loadUser();
        })
        .catch(err => {
          this.error =
            "Could not link the user profile. Please contact technical support.";
          console.log(err.response);
        })
        .finally(() => {
          this.isLinking = false;
        });
    },
    editUsername: function() {
      this.error = "";
      this.isEditingUsername = true;
    },
    cancelEditUsername: function() {
      this.error = "";
      this.user.username = this.originalUsername;
      this.isEditingUsername = false;
      this.username_invalid = false;
    },
    saveUsername: function() {
      this.error = "";
      this.isSavingUsername = true;

      // Validate the username
      if (this.user.username.trim().length == 0) {
        this.isSavingUsername = false;
        this.username_invalid = true;
        this.error = "Please enter a valid username.";
        return;
      }

      axios
        .post("/useredit/username", {
          UserId: this.userAccountId,
          Username: this.user.username
        })
        .then(() => {
          this.originalUsername = this.user.username;
          this.isEditingUsername = false;
        })
        .catch(err => {
          this.error = err.response.data;
        })
        .finally(() => {
          this.isSavingUsername = false;
        });
    },
    deleteAccount: function() {
      this.error = "";

      if (confirm("Are you sure you want to delete this user account?")) {
        axios
        .post("/useredit/delete", {
          UserId: this.userAccountId
        })
        .then(() => {
          this.$router.push("/usersearch");
        })
        .catch(err => {
          this.error = err.response.data;
        });
        // .finally(() => {
        //   this.isSavingUsername = false;
        // });
      }
    },
    filterLogs: function() {
      this.error = "";

      var tempArr = this.user.userEditLogs;

      tempArr = tempArr.filter((log) => { 
        var valueFound = false;       
        this.checkedLogFilters.forEach(lf => {
          if (log.type == lf) valueFound = true;
        });
        return valueFound;
      });

      this.userLogs = tempArr;
    },
    selectAllLogFilters: function() {
      this.checkedLogFilters = this.user.userLogTypes;
      this.filterLogs();
    },
    deselectAllLogFilters: function() {
      this.checkedLogFilters = [];
      this.filterLogs();
    }
  }
};
</script>

<style lang="scss" scoped>
/* IMPORT VARIABLES */
@import "@/styles/_variables.scss";

.header-section {
  display: flex;
  justify-content: space-between;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
}

.back-btn {
  margin-left: auto;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    img {
      padding-right: 5px;
    }
  }
}

.user-details-section {
  display: flex;
  flex-direction: column;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
  font-size: 0.9rem;

  div {
    margin-bottom: 0.8rem;
  }
}

.filters-section {
  display: flex;
  flex-direction: column;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  padding: 0.5rem;
}

.search-button {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  margin-bottom: 0 !important;
}

table {
  width: 100%;
  background: #f8f8ff;
  border: 1px solid $grey-color;
  border-collapse: collapse;
  font-size: 0.8rem;

  tr:nth-child(odd) {
    background: #ededff;
  }

  th {
    text-align: left;
    padding: 0.4rem;
    font-weight: bold;
    background: $dark-blue-color;
    color: $white-color;
  }

  th:last-child {
    width: 10%;
  }

  td {
    padding: 0.3rem 0.8rem;
  }
}

.searching-loader {
  width: 4rem;
  margin: 0 auto;
}

.link-loader {
  width: 1.5rem;
  margin: 0 auto;
}

.required {
  display: block;
  color: $danger-color;
}

 /* Style the tab */
.tab {
  overflow: hidden;
  border: 1px solid #ccc;
  background-color:#ededff;
}

/* Style the buttons that are used to open the tab content */
.tab button {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
}

/* Change background color of buttons on hover */
.tab button:hover {
  background-color: #697ee0;
  color: $white-color;
}

/* Create an active/current tablink class */
.tab button.active {
  background-color: $dark-blue-color;
  color: $white-color;
}

/* Style the tab content */
.tabcontent {
  display: none;
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-top: none;
}

.logfilters {
  border: 1px solid #ccc;
  background: $white-color;
  padding: 0.5rem;
  width: 230px;
}
</style>